const servicesCaseText = {

    eng: {
        servicesCaseHeader: "Services & Cases"
    },
    ru: {
        servicesCaseHeader: "Услуги и портфолио"
    },
    az: {
        servicesCaseHeader: "Xidmətlər və nümunələr",
    }
}

export default servicesCaseText